module.exports = __webpack_public_path__ + "img/faucet-drip.8b52498e.svg";